import { Flex } from "@redotech/redo-web/flex";
import { JSXElementConstructor, memo, SVGProps, useState } from "react";
import * as reviewsRatingCss from "./reviews-rating.module.css";

export const ReviewsRating = memo(function ReviewsRating({
  rating,
  Icon,
  iconSize = 24,
  iconColors = {
    filled: "#FEC84B",
    empty: "#E5E5E5",
  },
  editable = false,
  onRatingChange,
}: {
  rating: number | undefined;
  Icon: JSXElementConstructor<SVGProps<SVGSVGElement>>;
  iconColors?: {
    filled: string;
    empty: string;
  };
  iconSize?: number;
  editable?: boolean;
  onRatingChange?: (rating: number) => void;
}) {
  const [selectedRating, setSelectedRating] = useState<number | null>(null);
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);

  function handleSetSelectedRating(rating: number) {
    setSelectedRating(rating);
    onRatingChange?.(rating);
  }

  const handleMouseEnter = (index: number) => {
    editable ? setHoveredRating(index + 1) : null;
  };

  const handleMouseLeave = () => {
    editable ? setHoveredRating(null) : null;
  };

  const handleClick = (index: number) => {
    editable ? handleSetSelectedRating(index + 1) : null;
  };

  return (
    <Flex dir="row" gap="sm">
      {[...Array(5)].map((_, index) => {
        const fillPercentage =
          Math.min(
            Math.max(
              (hoveredRating ?? selectedRating ?? rating ?? 0) - index,
              0,
            ),
            1,
          ) * 100;
        return (
          <Flex
            align="center"
            className={reviewsRatingCss.iconWrapper}
            justify="center"
            key={index}
            onClick={() => handleClick(index)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <Icon
              className={reviewsRatingCss.icon}
              style={{
                color: iconColors.empty,
                width: iconSize,
                height: iconSize,
              }}
            />
            <Icon
              className={reviewsRatingCss.icon}
              style={{
                color: iconColors.filled,
                clipPath: `inset(0 ${100 - fillPercentage}% 0 0)`,
                position: "absolute",
                top: 0,
                left: 0,
                width: iconSize,
                height: iconSize,
              }}
            />
          </Flex>
        );
      })}
    </Flex>
  );
});
